module.exports = __webpack_public_path__ + "img/articleVisitors.f9f537b8.png";